import ConfirmationModal from "../../../components/ConfirmationModal";

const RemoveAllItemsConfirmationModal = ({ show, onClose, onContinue }) => (
    <ConfirmationModal
        show={show}
        title="Are you sure you want to remove all items?"
        description="Every item currently listed is cleared from the quotation."
        variant="danger"
        confirmLabel="Remove All Items"
        cancelLabel="Discard"
        onCancel={onClose}
        onConfirm={onContinue}
    />
);

export default RemoveAllItemsConfirmationModal;
